import { ENDPOINTS } from '../utils/endpoints';
import { getAPIwithToken, postAPIwithToken, putAPIwithToken } from '../utils/fetchApi';

export interface ApiDistributorChannel {
  id: number;
  sapTypeId?: number | null;
  name?: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
  code?: string;
  status?: number | string | boolean;
}

export interface GetDistributorChannelsResponse {
  status: string;
  message?: string;
  data: ApiDistributorChannel[];
}

export interface CreateDistributorChannelPayload {
  name: string;
  description?: string;
  sapTypeId?: number;
}

export interface UpdateDistributorChannelPayload {
  name?: string;
  description?: string;
  sapTypeId?: number;
}

export async function getDistributorChannelsList(): Promise<GetDistributorChannelsResponse> {
  return getAPIwithToken<GetDistributorChannelsResponse>(ENDPOINTS.DISTRIBUTOR_CHANNELS);
}

export async function createDistributorChannel(
  payload: CreateDistributorChannelPayload
): Promise<any> {
  return postAPIwithToken(ENDPOINTS.DISTRIBUTOR_CHANNELS, payload);
}

export async function updateDistributorChannel(
  id: number | string,
  payload: UpdateDistributorChannelPayload
): Promise<any> {
  return putAPIwithToken(ENDPOINTS.UPDATE_DISTRIBUTOR_CHANNEL(id), payload);
}
